<template>
    <div>
        <page-hero
            :heroImage="heroImage"
            :pageTitle="pageTitle"
            :imageAltText="imageAltText"
        ></page-hero>

        <v-container
            class="mt-10"
            style="max-width: 1185px"
        >
            <v-row
                align="center"
                justify="space-around"
            >
                <v-col
                    col="6"
                    align="left"
                >
                    <page-subheading title="Working at Prospira"></page-subheading>
                </v-col>
                <v-col
                    col="6"
                    align="right"
                >
                    <navigation-button
                        text="View Job Openings"
                        externalURL="https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=7806570f-74c5-44b8-911a-519422af717b&ccId=19000101_000001&lang=en_US"
                    ></navigation-button>
                </v-col>
            </v-row>

            <benefits-card></benefits-card>

            <health-clinic-card></health-clinic-card>

            <our-values-card></our-values-card>

            <v-col
                col="6"
                align="center"
            >
                <navigation-button
                    text="View Job Openings"
                    externalURL="https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=7806570f-74c5-44b8-911a-519422af717b&ccId=19000101_000001&lang=en_US"
                ></navigation-button>
            </v-col>
 
        </v-container>

    </div>
</template>

<script>
import BenefitsCard from '@/components/careers/BenefitsCard.vue'
import HealthClinicCard from '@/components/careers/HealthClinicCard.vue'
import NavigationButton from '@/components/global/NavigationButton.vue'
import OurValuesCard from '@/components/careers/OurValuesCard.vue'
import PageHero from '@/components/PageHero.vue'
import PageSubheading from '@/components/PageSubheading.vue'

export default {
    components: {
        'benefits-card': BenefitsCard,
        'health-clinic-card': HealthClinicCard,
        'navigation-button': NavigationButton,
        'our-values-card': OurValuesCard,
        'page-hero': PageHero,
        'page-subheading': PageSubheading
    },
    name: 'CareersView',
    data: () => {
        return {
            heroImage: require('@/assets/careers/careers_hero1800x1200.jpg'),
            pageTitle: "Careers",
            imageAltText: "Stock image of two individuals shacking hands"
        }
    }
}
</script>
